import { Component, effect, inject, OnDestroy } from '@angular/core';
import { NonNullableFormBuilder, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FormValidators } from '@corelabs/angular/forms';
import { ButtonModule } from 'primeng/button';
import { FormInputComponent, FormPasswordComponent } from '@shared/forms';
import { AdminFacade } from '@app/store/admin';

@Component({
    selector: 'app-admin-add-modal',
    templateUrl: './add.component.html',
    styleUrls: ['./add.component.css'],
    imports: [ReactiveFormsModule, TranslateModule, ButtonModule, FormInputComponent, FormPasswordComponent],
})
export class AddComponent implements OnDestroy {
    private readonly router = inject(Router);
    private readonly adminFacade = inject(AdminFacade);
    private readonly formBuilder = inject(NonNullableFormBuilder);

    readonly saving = this.adminFacade.saving;

    readonly form = this.formBuilder.group({
        firstName: this.formBuilder.control('', [FormValidators.Required, FormValidators.Text]),
        lastName: this.formBuilder.control('', [FormValidators.Required, FormValidators.Text]),
        email: this.formBuilder.control('', [FormValidators.Required, FormValidators.Email]),
        password: this.formBuilder.control('', [
            FormValidators.Required,
            FormValidators.Password({ minLength: 8, lowercaseLetters: 1, uppercaseLetters: 1, numbers: 1, symbols: 1 }),
        ]),
    });

    constructor() {
        effect(() => {
            if (this.adminFacade.saved()) {
                this.close();
            }
        });

        effect(() => {
            if (this.adminFacade.saving() === false && this.adminFacade.saved() === false) {
                this.form.enable();
            }
        });
    }

    ngOnDestroy(): void {
        this.adminFacade.clear();
    }

    onSubmit(): void {
        this.form.markAllAsTouched();

        if (this.form.valid) {
            this.form.disable();
            this.adminFacade.createAdmin(this.form.getRawValue());
        }
    }

    close(): void {
        this.router.navigate([{ outlets: { modal: null } }]);
    }
}
